var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('Navbar',{attrs:{"title":_vm.$t('nav.activityDetails')}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }